export class LoggerConfigRecord {

    timestamp: Date;
    oldValue: any;
    newValue: any;
    source?: string;

    constructor(timestamp: Date, oldValue: any, newValue: any, source?: string) {
        this.timestamp = timestamp;
        this.oldValue = oldValue;
        this.newValue = newValue;
        this.source = source;
    }

    getTimestamp(): Date {
        return this.timestamp;
    }

    getOldValue(): any {
        return this.oldValue;
    }

    getNewValue(): any {
        return this.newValue;
    }

    getSource(): string | undefined {
        return this.source;
    }
}